// @core/api/endpoints/task/get_task_category.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TaskCategoryResponse,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Get task category
 * Returns a task category by ID.
 */
export async function GetTaskCategory(
  category_id: string,
  options?: RequestOptions
): Promise<TaskCategoryResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/task-categories/:category_id`;
  requestPath = requestPath.replace(':category_id', encodeURIComponent(category_id));
  const requestOptions = options;
  return client.get<TaskCategoryResponse>(requestPath, { ...requestOptions });
}
